<template>
    <transition name="fadeIn" appear>
        <BaseLayout>
            <nav class="nav">
                <div class="navItems">
                    <Button
                        tabindex="0"
                        appearance="tabButton"
                        size="fullWidth"
                        prefixIcon="magic_button"
                        @click="isSelected = 'featured'">
                        {{ siteContent.featured }}
                        <div class="indicator"
                            v-if="isSelected === 'featured'"></div>
                    </Button>
                    <Button
                        v-if="auth.id"
                        tabindex="0"
                        appearance="tabButton"
                        size="fullWidth"
                        prefixIcon="person_add_alt"
                        @click="isSelected = 'following'">
                        {{ siteContent.following }}
                        <div class="indicator"
                            v-if="isSelected === 'following'"></div>
                    </Button>
                    <Button
                        tabindex="0"
                        appearance="tabButton"
                        size="fullWidth"
                        prefixIcon="stream"
                        @click="isSelected = 'all'">
                        {{ siteContent.fresh }}
                        <div class="indicator"
                            v-if="isSelected === 'all'"></div>
                    </Button>
                </div>
            </nav>
            
            <Main class="resetMainMargin">
                <FeaturedEntries  v-if="isSelected === 'featured'"/>
                <FollowingEntries v-else-if="isSelected === 'following'"/>
                <AllEntries       v-else-if="isSelected === 'all'"/>
            </Main>
        </BaseLayout>
    </transition>
</template>

<script>
    import BaseLayout       from '@/components/layout/main/BaseLayout'
    import Main             from '@/components/layout/main/Main'
    import FeaturedEntries  from '@/components/home/FeaturedEntries'
    import FollowingEntries from '@/components/home/FollowingEntries'
    import AllEntries       from '@/components/home/AllEntries'

    export default {
        name: 'Home',
        components: {
            BaseLayout,
            Main,
            FeaturedEntries,
            FollowingEntries,
            AllEntries
        },
        data() {
            return {
                isSelected: 'featured'
            }
        },
        metaInfo() {
            if(this.preferences.language === 'hu') {
                return {
                    title: 'Creatillo',
                    meta: [
                        { vmid: 'description', name: 'description', content: 'Az új generációs képmegosztó platform.' }
                    ]
                }
            } else {
                return {
                    title: 'Creatillo',
                    meta: [
                        { vmid: 'description', name: 'description', content: 'The new generation image sharing platform.' }
                    ]
                }
            }
        }
    }
</script>


<style scoped lang="scss">
    @import '../scss/variables';

    .resetMainMargin {
        margin-top: 2rem;
    }

    .nav {
        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;
    }

    .navItems {
        display: flex;
        color: var(--color-white-important);
        align-items: center;
        max-width: 32rem;
        width: 100%;
    }
</style>